import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  items:{

  },
  invoiceExtraData:{

  },
  pdfUrl:''

}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {
  LOADING_INVOICES (state, isLoading){
    state.status.loading = isLoading
  },

  SET_INVOICES (state, data){
    state.items = data
  },
  SET_INVOICE_EXTRA_DATA (state, data){
    state.invoiceExtraData = data
  },
  SET_PDF_URL (state, data){
    state.pdfUrl = data
  }
}

//async methods  store.dispatch('increment')
const actions = {


  loadInvoiceStore ({state, commit}, [page,status]) {

    commit('LOADING_INVOICES', true);

    return api.get('order?page='+page+'&status='+status)
      .then(function (response) {
        commit('SET_INVOICE_EXTRA_DATA', response.data.order)
        commit('SET_INVOICES', response.data.order.data)

        commit('LOADING_INVOICES', false);
      })
      .catch(function (error) {
        commit('LOADING_INVOICES', false);

      });
  },

  getPdfUrl ({state, commit}, orderId) {

    commit('LOADING_INVOICES', true);

    return api.get('order/'+orderId+'/invoice')
      .then(function (response) {
        commit('SET_PDF_URL', response.data.url)
      
        commit('LOADING_INVOICES', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_INVOICES', false);
        return Promise.reject(error);

      });
  }

}


export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/InvoiceStore.js